// @internal
import styled from 'styled-components';
import { OutlineStyles, StyledSideNavProps } from '../../styles';
import { sidenavTokens } from '../../../../tokens/components/SideNav/tokens';
import { controllerTokens } from '../../../../tokens/components/Controller/tokens';

type StyledSideNavFilterProps = Pick<StyledSideNavProps, 'isClosed'> & React.HTMLAttributes<HTMLInputElement>;

export const StyledSideNavFilter = styled.input<StyledSideNavFilterProps>`
  margin: 0;
  line-height: ${sidenavTokens.FilterFontLeadingBaseDefault};
  background-color: ${sidenavTokens.FilterBackgroundColorBaseDefault};
  border: 1px solid ${sidenavTokens.FilterBorderColorBaseDefault};
  font-family: ${controllerTokens.ContainerFontFamilyBaseDefault};
  font-size: ${sidenavTokens.FilterFontSizeBaseDefault};
  padding: ${sidenavTokens.FilterPaddingBaseDefault};
  display: ${({ isClosed }) => (isClosed ? 'none' : 'block')};
  width: 100%;

  ${OutlineStyles}

  &:focus {
    background-color: ${sidenavTokens.FilterBackgroundColorBaseKeyboardFocus};
  }

  ::placeholder {
    color: ${sidenavTokens.FilterPlaceholderFontColorBaseDefault};
  }
`;

/* @internal */
export const StyledSideNavFilterWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  position: relative;
  min-width: 0;
`;

type StyledSideNavFilterKeyboardShortcutLabelProps = Pick<StyledSideNavProps, 'isClosed'> &
  React.HTMLAttributes<HTMLSpanElement>;

/* @internal */
export const StyledSideNavFilterKeyboardShortcut = styled.span<StyledSideNavFilterKeyboardShortcutLabelProps>`
  position: absolute;
  top: 4px;
  right: 8px;
  font-size: 13px;
  display: ${({ isClosed }) => (isClosed ? 'none' : 'inline')};
  color: ${sidenavTokens.FilterPlaceholderFontColorBaseDefault};
  pointer-events: none;
`;
